import { SET_REVIEW_URL } from "../../Actions/Types";
import { G2ReviewRequestApi, G2ReviewUrlApi } from "../../Api/UseG2ReviewApi";

// service to get translations
const G2ReviewUrlService = async (
    partner_name: string, //partner_name name
    email:string, // email name
    dispatch:Function
) => {
    try {
            const res = await G2ReviewRequestApi(email);

            if (res.review_exists === "false" || res.review_exists === false) {
                const response = await G2ReviewUrlApi(partner_name, email);

                dispatch({
                    type: SET_REVIEW_URL,
                    payload: response,
                });

                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error(error);
            return false;
        }
    
}

export { G2ReviewUrlService };